import {Step} from 'react-joyride';
import {tourText} from '../../texts/analyticsText';
import {stepConfig} from './analyticsStepConfig';
import {buildSteps} from '../../utils/buildSteps';

export const getAnalyticsSteps = (): Step[] =>
  buildSteps(stepConfig, tourText, 'Analytics');
